import { render, staticRenderFns } from "./AppUserBar.vue?vue&type=template&id=be87beee&scoped=true&"
import script from "./AppUserBar.vue?vue&type=script&lang=js&"
export * from "./AppUserBar.vue?vue&type=script&lang=js&"
import style0 from "./AppUserBar.vue?vue&type=style&index=0&id=be87beee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be87beee",
  null
  
)

/* custom blocks */
import block0 from "./AppUserBar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports